var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2718 1.83398C18.3885 1.83398 20.1668 3.59398 20.1668 6.71982V15.2815C20.1668 18.389 18.3977 20.1673 15.281 20.1673H6.71933C3.5935 20.1673 1.8335 18.389 1.8335 15.2815V6.71982C1.8335 3.59398 3.5935 1.83398 6.71933 1.83398H15.2718ZM10.991 6.88482C10.5693 6.88482 10.2302 7.22398 10.2302 7.64565V10.2307H7.636C7.43433 10.2307 7.24183 10.3132 7.09516 10.4507C6.95766 10.5973 6.87516 10.7889 6.87516 10.9915C6.87516 11.4132 7.21433 11.7523 7.636 11.7615H10.2302V14.3557C10.2302 14.7773 10.5693 15.1165 10.991 15.1165C11.4127 15.1165 11.7518 14.7773 11.7518 14.3557V11.7615H14.3552C14.7768 11.7523 15.116 11.4132 15.116 10.9915C15.116 10.5698 14.7768 10.2307 14.3552 10.2307H11.7518V7.64565C11.7518 7.22398 11.4127 6.88482 10.991 6.88482Z",
    fill: "#605BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCertificate);
export default __webpack_public_path__ + "static/media/plus-certificate.fe6a618491b2dc7cc8108be028683506.svg";
export { ForwardRef as ReactComponent };